export const routes = {
    home: "/",
    splash: "/splash",
    finish: "/finish",
    agreements: "/agreements",
    simpleCert: {
        request: "/simple-cert/request",
        confirm: "/simple-cert/confirm",
    },
};
